import axios from "axios";
import React, { useEffect, useState } from "react";

import ImageLoading from "../../../components/ImageLoading";
import { FiDownload } from "react-icons/fi";
import IconDownloadButton from "../../../components/IconDownloadButton";

const NewTablePledged = ({ checkPledged }) => {
  const [topPledgedMutualFunds, setTopPledgedMutualFunds] = useState([]);
  const [fundDownload, setFundDownload] = useState(false);

  const [hasPledgedFund, setHasPledgedFund] = useState(true);
  const [loading, setLoading] = useState(false);

  const getTopPledgedMutualFundsNew = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/top_pledged_mutual_funds`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      //   console.log(res.data.top_pledged_mutual_funds);
      if (!res.data.top_pledged_mutual_funds.length) setHasPledgedFund(false);
      else {
        setHasPledgedFund(true);
      }
      setTopPledgedMutualFunds(res.data.top_pledged_mutual_funds);
      setLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    getTopPledgedMutualFundsNew();
  }, []);

  checkPledged(hasPledgedFund);

  function truncateString(str) {
    if (str === null) return "---";
    const maxLength = 50;
    if (str.length <= maxLength) {
      return str;
    } else {
      return str.substring(0, maxLength) + "...";
    }
  }
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  const handleExcelDownload = async () => {
    // setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/pledged_mutual_funds_excel?download=true&pledged_mutual_fund_type=mutual_funds`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.download_url.status) {
        handleDownloadFile(res.data.download_url.data);
        // setDownloadLoading(false);
      }
    } catch (error) {
      // setDownloadLoading(false);
      console.log(error);
    } finally {
    }
  };
  
  return (
    <>
      {loading ? (
        <>
          <div className="flex w-full h-[30vh] justify-center items-center ">
            <ImageLoading />
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className="bg-white h-full overflow-y-scroll rounded-lg">
            <div className="text-[16px] font-semibold  px-4 mt-[17px] mb-[14px] flex justify-between items-center">
              <p>Top 5 Pledged Securities</p>
              <button onClick={() => handleExcelDownload()}>
                {" "}
                <IconDownloadButton
                  bg="bg-[#00394d]"
                  iconColor={"text-white"}
                />
              </button>
            </div>

            <table className="w-full">
              <thead className=" bg-[#e6ebed] text-sm">
                <th className=" h-[36px] w-[15%]">No.</th>
                <th className=" w-[55%] text-left">Mutual Fund Name</th>
                <th>Units</th>
                <th>No. of Users</th>
              </thead>
              <tbody className=" text-center text-xs font-medium ">
                {topPledgedMutualFunds?.map((item, index) => (
                  <tr
                    key={index}
                    className={` ${
                      index % 2 === 0 ? "bg-[#ffffff]" : "bg-[#f8f8f8]"
                    }`}
                  >
                    <td className=" h-[36px]">{index + 1}</td>
                    <td
                      className=" text-left"
                      title={
                        item?.scheme_name?.length > 50 ? item.scheme_name : ""
                      }
                    >
                      {item.scheme_name ? truncateString(item.scheme_name) : ""}
                    </td>
                    <td>{item.units}</td>
                    <td className="">{item.user_count}</td>
                  </tr>
                ))}
                <td></td>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default NewTablePledged;
